import type { ServiceProvider, ServiceContainer } from "../service-container";
import type { ColorResamplerFactoriesPool } from "./ColorResamplerFactoriesPool";
import { BasePool } from "../pool";
import { EwaResamplerFactory } from "./EwaResamplerFactory";
import { PointResamplerFactory } from "./PointResamplerFactory";
import { BaseColorResamplerResolver } from "./BaseColorResamplerResolver";

/**
 * Color Resampling service provider.
 * @internal
 */
export const colorResamplerProvider: ServiceProvider = {
  /**
   * Registers entities, related to color resampling in service container.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    // register pool items once. TODO: improve ServiceContainer for better handling such cases
    let colorResamplerFactoriesPoolRegistered = false;

    // Register default color resampler resolver in service container.
    container.register("ColorResamplerResolver", (c) => {
      if (!colorResamplerFactoriesPoolRegistered) {
        const colorInterpolatorFactory = c.resolve("ColorInterpolatorFactory");
        // Add built-in color resampler factories to the pool and register pool in service container.
        const pool: ColorResamplerFactoriesPool = new BasePool();
        pool.add("ewa", new EwaResamplerFactory(colorInterpolatorFactory));
        pool.add("point", new PointResamplerFactory(colorInterpolatorFactory));
        c.register("ColorResamplerFactoriesPool", pool);
        colorResamplerFactoriesPoolRegistered = true;
      }

      return new BaseColorResamplerResolver(
        c.resolve("ColorResamplerFactoriesPool"),
        c.resolve("ResampleFilterResolver")
      );
    });
  },
};
